import * as Sentry from "@sentry/browser";
import { updateCheckout, completeCheckoutWithPayment } from "./actions";
import { CheckoutUpdateInput } from "../web-nextjs/__generated__/globalTypes";
import { completeCheckout_completeCheckoutWithPayment_checkout } from "../web-nextjs/__generated__/completeCheckout";

interface MakeOrderProps {
  shippingId: string;
  paymentId: string;
  pickup: boolean;
  name: string;
  phone: string;
  address: string;
  apartment: string;
  floor: string;
  entrance: string;
  doorphone: string;
  deliveryDate: string;
  deliveryTime: string;
  comment: string;
  bonuses: number;
}

export type MakeOrder = (props: MakeOrderProps) => Promise<{
  checkout?: completeCheckout_completeCheckoutWithPayment_checkout;
  url?: string | null;
  shippingLineError?: boolean;
}>;

interface UseOrderResult {
  makeOrder: MakeOrder;
}

export default function useOrder({ checkoutId, client }): UseOrderResult {
  async function makeOrder({
    shippingId,
    paymentId,
    comment,
    address,
    apartment,
    floor,
    entrance,
    doorphone,
    name,
    phone,
    pickup,
    deliveryDate,
    deliveryTime,
    bonuses,
  }: MakeOrderProps) {
    try {
      const customAttributes = [
        {
          key: "Имя",
          value: name,
        },
      ];

      const data: CheckoutUpdateInput = {
        note: comment,
        phone: phone.replace(/[\s,-]/g, ""),
        customerName: name || "",
        iikoBonusesUse: bonuses || 0,
      };

      if (pickup) {
        data.shippingLine = {
          connect: {
            id: shippingId,
          },
        };
      } else {
        data.shippingAddress = {
          create: {
            address1: address,
            address2: `${apartment}|${floor}|${entrance}|${doorphone}`,
            name,
            phone,
          },
        };
      }

      if (deliveryDate && deliveryTime) {
        data.customAttributes = {
          create: [
            ...customAttributes,
            {
              key: "Ко времени",
              value: `${deliveryDate}, ${deliveryTime}`,
            },
          ],
        };
      }

      await updateCheckout(client, checkoutId, paymentId, data);
      const result = await completeCheckoutWithPayment(
        client,
        checkoutId,
        paymentId
      );
      return result;
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
    }
  }

  return {
    makeOrder,
  };
}
